/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useEffect, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../../tableIcons";
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import { Typography, Button, makeStyles } from "@material-ui/core";
import { AddCircleOutline } from "@material-ui/icons";
import { format } from "date-fns";
import SnackBar from "../../Snackbar/index";
import SecureWrapper from "../../Security/SecureWrapper";

const blue_theme = createTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const useStyles = makeStyles(() => ({
  button: {
    width: "80px",
    background: "#127DFC",
    textTransform: "none",
    color: "#FFFFFF",
    float: "right",
    margin: "10px",
    boxShadow: "0px 3px 6px #0000001A",
    border: "none",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: "#0069d9",
      borderColor: "#0062cc",
      boxShadow: "none",
    },
  },
}));

const RolesTable = (props) => {
  const classes = useStyles();
  const {
    data,
    toggle,
    setToggle,
    setSelectedData,
    isNew,
    setIsNew,
    deleted,
    setdeleted,
    isCreate,
    newdata,
    setisCreate,
  } = props;
  console.log("rrrt", data?.result);
  const [role, setRole] = useState(null);
  const [open, setopen] = useState(false);
  const [isdeleted, setisdeleted] = useState(false);
  useEffect(() => {}, [data]);

  const handleNewRole = () => {
    // if (role === null) {
    //   console.log("new clicked");
    setIsNew(true);
    setRole(null);
    setToggle(false);
    // } else {
    //   setIsNew(false);
    // }
  };
  const handleRowSelected = (rowData) => {
    // console.log("rowData", rowData);
    if (role === rowData?.tableData.id) {
      setToggle(!toggle);
      setRole(null);
    } else {
      setToggle(true);
      setRole(rowData?.tableData.id);
    }
    setSelectedData(rowData);
    setIsNew(false);
  };
  useEffect(() => {
    data?.result?.map((row) => {
      if (row.tableData.id === role) {
        setSelectedData(row);
        console.log("uptate data row", row);
      }
      if (isCreate && row.name === newdata) {
        setSelectedData(row);
        setRole(row.tableData.id);
        setToggle(true);
        setisCreate(false);
      }
    });
  }, [data]);


  useEffect(() => {
    if (deleted === true) {
      setToggle(!toggle);
      setRole(null);
      setdeleted(false);
      setisdeleted(true);
    }
    if (isCreate) {
      setopen(true);
    }
  });

  const onClose = () => {
    setopen(false);
  };


  const onClosedeleted = () => {
    setisdeleted(false);
  };


  return (
    <ThemeProvider theme = {blue_theme}>
    <div style={{ maxWidth: "100%", display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h6 style={{ paddingLeft: "10px" }}>All Roles</h6>
        <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/role",
                        method : "POST",
                        operands : []
                      }}
          >
          <Button
            variant = 'contained'
            size = 'small'
            color = 'primary'
            startIcon={<AddCircleOutline />}
            style={{margin: '10px',  visibility: isNew ? "hidden" : "visible" }}
            onClick={handleNewRole}
          >
            New
          </Button>
        </SecureWrapper>
      </div>
      <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/role",
                        method : "GET",
                        operands : []
                      }}
                      shouldRenderErrorMessage = {true}
                      errorMessage = "User does not have sufficient privileges"
                      textVariant = "subtitle2"
          >
      <MaterialTable
        data={data?.result}
        icons={table_icons}
        columns={[
          {
            title: "Role",
            field: "name",
            searchable: true,
            sorting: true,
            cellStyle: {
              width: "30rem",
              //   textAlign: "center",
            },
            render: (rowData) => {
              return (
                <div
                  style={{
                    color: role === rowData?.tableData.id ? "#FFF" : "#222222",
                    fontWeight: "bold",
                    fontSize: "13px",
                  }}
                >
                  {rowData?.name || "-"}
                </div>
              );
            },
          },
          // {
          //   title: "Description",
          //   field: "description",
          //   cellStyle: {
          //     width: "25rem",
          //     //   textAlign: "center",
          //   },
          //   render: (rowData) => {
          //     return (
          //       <div
          //         style={{
          //           color: role === rowData?.tableData.id ? "#FFF" : "#222222",
          //         }}
          //       >
          //         {rowData?.description || "-"}
          //       </div>
          //     );
          //   },
          // },
          {
            title: "Group",
            field: "group_name",
            searchable: true,
            sorting: true,
          },
          {
            title: "Created On",
            field: "created_date",
            searchable: true,
            sorting: true,
            type: "datetime",
            cellStyle: {
              width: "15rem",
              color: "#707071",
              fontWeight: "bold",
              // textAlign: "center",
            },
            render: (rowData) => {
              return (
                <Typography variant = 'caption' color = 'textSecondary'>{format(new Date(rowData?.created_date), "dd MMM yyyy")}</Typography>
              );
            },
          },
          {
            title: "Updated On",
            field: "updated_date",
            searchable: true,
            sorting: true,
            type: "datetime",
            cellStyle: {
              width: "15rem",
              color: "#707071",
              fontWeight: "bold",
              // textAlign: "center",
            },
            render: (rowData) => {
              return (
                <Typography variant = 'caption' color = 'textSecondary'>{format(new Date(rowData?.updated_date), "dd MMM yyyy")}</Typography>
              );
            },
          },
          // {
          //   title: "",
          //   render: (rowData) => {
          //     return renderEventGroupActions();
          //   },
          //   cellStyle: {
          //     width: "5rem",
          //   },
          // },
        ]}
        components={{
          Toolbar: (props) => (
            <div style={{ background: "#F8FCFF" }}>
              <MTableToolbar {...props} />
            </div>
          ),
        }}
        options={{
          // search: false,
          // toolbar: false,
          showTitle: false,
          paging: true,
          actionsColumnIndex: 5,
          actionsCellStyle: {
            // background: "grey",
          },
          minBodyHeight: "67.5vh",
          maxBodyHeight: "70vh",
          //   pageSizeOptions: [10, 20, 30],
          pageSize: 10,
          headerStyle: {
            background: "#F8FCFF",
            color: "#707071",
            // fontSize: "1rem",
            // fontWeight: "bold",
            // paddingBottom: "0px",
          },
          rowStyle: (rowData) => ({
            backgroundColor: role === rowData.tableData.id ? "#70BAFA" : "#FFF",
          }),
        }}
        onRowClick={(event, rowData) => {
          handleRowSelected(rowData);
        }}
      />
      </SecureWrapper>
      {open && (
        <SnackBar
          openDialog={open}
          message={"Role has been created successfully"}
          onclose={onClose}
          severity={"success"}
        />
      )}
      {isdeleted && (
        <SnackBar
          openDialog={isdeleted}
          message={"Role has been deleted successfully"}
          onclose={onClosedeleted}
          severity={"success"}
        />
      )}
    </div>
    </ThemeProvider>
  );
};

export default RolesTable;
